import { PurchasesClient } from './purchases-client';

export const metadata = { title: 'Purchase History | Alqove' };

export default function PurchasesPage() {
  return <PurchasesClient />;
}
